import { useTranslation } from "react-i18next";
import { getHours } from "date-fns";

import { greetingForHour } from "./greetingForHour";
import { useNow } from "./use-now";

export const Greeting = () => {
  const { t } = useTranslation("my-space");
  const now = useNow("hour");

  return <h6 className="text-sm text-primary-strong/70">{t(greetingForHour(getHours(now)))}</h6>;
};
